import React, { useState, useEffect } from 'react';
import { Group, Text, SimpleGrid, Card, Button } from '@mantine/core';
import { useParams, useNavigate } from 'react-router-dom';
import api, { Shelf } from '../services/api';

function BookShelf() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [shelf, setShelf] = useState<Shelf | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadShelf = async () => {
      try {
        const data = await api.shelves.getById(id!);
        setShelf(data);
      } catch (error) {
        console.error('Ошибка при загрузке полки:', error);
      } finally {
        setLoading(false);
      }
    };
    loadShelf();
  }, [id]);

  if (loading) {
    return <Text>Загрузка...</Text>;
  }

  if (!shelf) {
    return <Text>Полка не найдена</Text>;
  }

  return (
    <div className="shelf">
      <Text size="xl" fw={700} mb="md">
        {shelf.name}
      </Text>
      <SimpleGrid cols={2} spacing="lg">
        {shelf.books.map((book) => (
          <Card key={book.id} shadow="sm" padding="lg" radius="md" withBorder>
            <Group justify="space-between" mb="xs">
              <Text fw={500}>{book.title}</Text>
            </Group>
            <Text size="sm" c="dimmed">
              {book.description}
            </Text>
            <Button
              variant="light"
              color="blue"
              fullWidth
              mt="md"
              radius="md"
              onClick={() => navigate(`/book/${book.id}`)}
            >
              Подробнее
            </Button>
          </Card>
        ))}
      </SimpleGrid>
    </div>
  );
}

export default BookShelf;